import { render } from "./NewMessage.vue?vue&type=template&id=5eae99ac&ts=true"
import script from "./NewMessage.vue?vue&type=script&lang=ts"
export * from "./NewMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__